import { useQuery } from 'data-fetching-client';
import { useMemo } from 'react';
// @ts-expect-error module is untyped
import localeComparator from 'I18n/utils/localeComparator';
import unescapedText from 'I18n/utils/unescapedText';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import * as ThemeQueryField from 'marketplace-ui-assets-core/constants/ThemeQueryField';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import { GET_PROVIDERS } from '../../../queries/providerFilterQuery';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingComponent = () => /*#__PURE__*/_jsx(UILoadingSpinner, {
  size: "extra-small"
});
const ProviderFilter = ({
  disabled,
  offeringType = 'THEME',
  onChange,
  scrollable = true,
  value
}) => {
  const {
    loading,
    error,
    data,
    previousData
  } = useQuery(GET_PROVIDERS, {
    variables: {
      offeringType
    }
  });
  const providersOptions = useMemo(() => {
    /* combine into one variable to make TS happy */
    const providersData = data || previousData;
    if (!providersData) {
      return [];
    }
    const {
      providers: {
        providerNames
      }
    } = providersData;
    if (!providerNames) {
      return [];
    }
    return providerNames.map(item => ({
      text: item,
      value: item
    })).sort((a, b) => localeComparator(a.text, b.text));
  }, [data, previousData]);
  const providerNamesRequestState = useMemo(() => {
    if (loading) {
      return RequestState.PENDING;
    }
    if (error) {
      return RequestState.FAILED;
    }
    if (!data && !previousData) {
      return RequestState.UNINITIALIZED;
    }
    return RequestState.SUCCEEDED;
  }, [data, error, loading, previousData]);
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    LoadingComponent: LoadingComponent,
    requestStatus: providerNamesRequestState,
    showLoadingOnUninitialized: true,
    children: /*#__PURE__*/_jsx(FilterToggleGroup, {
      ariaLabel: unescapedText('marketplace-assets-ui.assets.filters.providers.title'),
      disabled: disabled,
      multi: true,
      name: ThemeQueryField.PROVIDERS,
      onChange: onChange,
      options: providersOptions,
      scrollable: scrollable,
      value: value,
      virtualized: scrollable
    })
  });
};
export default ProviderFilter;